import { HyperlinkModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class HyperlinkService extends ApiService<HyperlinkModel> {
	constructor() {
		super('hyperlink');
	}
}

export default new HyperlinkService();
